import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import RenewalSuggestionRenderer from './RenewalSuggestionRenderer';
import './FlatRenewalSuggestionsList.less';

const FlatRenewalSuggestionsList: React.FC = () => {
    const { renewalSuggestionsStore } = useAppStore();

    return (
        <div className="flat-renewal-suggestions-list-container">
            {renewalSuggestionsStore.defaultGroupSuggestions.map((suggestion, index) => (
                <RenewalSuggestionRenderer
                    key={`${suggestion.businessId}-${index}`}
                    suggestionsKey={renewalSuggestionsStore.defaultGroupKey}
                    suggestion={suggestion}
                />
            ))}
        </div>
    );
};

export default observer(FlatRenewalSuggestionsList);
